import React from "react";

function ReturnIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.125 8.75C18.1236 10.0756 17.5963 11.3466 16.6589 12.2839C15.7216 13.2213 14.4506 13.7486 13.125 13.75H6.875V16.875C6.8751 16.9987 6.8385 17.1196 6.76983 17.2225C6.70116 17.3254 6.60351 17.4055 6.48925 17.4529C6.37498 17.5002 6.24924 17.5126 6.12794 17.4885C6.00663 17.4643 5.89523 17.4047 5.80782 17.3172L2.05782 13.5672C1.99971 13.5091 1.95361 13.4402 1.92215 13.3643C1.8907 13.2885 1.87451 13.2071 1.87451 13.125C1.87451 13.0429 1.8907 12.9615 1.92215 12.8857C1.95361 12.8098 1.99971 12.7409 2.05782 12.6828L5.80782 8.93281C5.89523 8.84531 6.00663 8.7857 6.12794 8.76154C6.24924 8.73739 6.37498 8.74977 6.48925 8.79711C6.60351 8.84446 6.70116 8.92464 6.76983 9.02751C6.8385 9.13038 6.8751 9.25132 6.875 9.375V12.5H13.125C14.1196 12.5 15.0734 12.1049 15.7767 11.4017C16.4799 10.6984 16.875 9.74456 16.875 8.75C16.875 7.75544 16.4799 6.80161 15.7767 6.09835C15.0734 5.39509 14.1196 5 13.125 5H6.25C6.08424 5 5.92527 4.93415 5.80806 4.81694C5.69085 4.69973 5.625 4.54076 5.625 4.375C5.625 4.20924 5.69085 4.05027 5.80806 3.93306C5.92527 3.81585 6.08424 3.75 6.25 3.75H13.125C14.4506 3.75145 15.7216 4.2787 16.6589 5.21607C17.5963 6.15343 18.1236 7.42436 18.125 8.75Z"
          fill="#D800B0"
        />
      </svg>
    </>
  );
}

export default ReturnIcon;
